// Source: https://data.iana.org/TLD/tlds-alpha-by-domain.txt
// Version 2026040600, Last Updated Mon Apr 6 07:07:02 2026 UTC

const validTlds = new Set(["ai", "biz", "co", "com", "edu", "gov", "info", "io", "me", "mil", "net", "org", "us"]);

export default validTlds;
